import { allValuesFor } from "../../utils/types";
export const videoKinds = allValuesFor()('youtube', 'vimeo', 'html5');
export const isVideoKind = (value)=>videoKinds.includes(value);
export const asVideoKind = (value, fallback)=>{
    const kind = isVideoKind(value) ? value : fallback;
    const valid = isVideoKind(value);
    return [
        kind,
        valid
    ];
};
export const processVideoIframeUrl = (video)=>{
    if (!video.Url) throw new Error("Video URL is missing");
    switch(video.Kind){
        case 'youtube':
            return processYouTubeUrl(video.Url);
        case 'vimeo':
            return processVimeoUrl(video.Url);
        default:
            throw new Error(`The video type ${video.Kind} is not (yet) supported`);
    }
};
const processYouTubeUrl = (urlString)=>{
    if (!urlString.toLowerCase().includes('youtu')) throw new Error("Not a YouTube URL");
    const originalUrl = new URL(urlString);
    const id = originalUrl.searchParams.get('v') || originalUrl.pathname.split('/').pop();
    const targetUrl = new URL(id ? `https://www.youtube-nocookie.com/embed/${id}` : urlString);
    targetUrl.searchParams.set("disablekb", "1"); // Keyboard controls can interfere with screen readers
    targetUrl.searchParams.set("color", "white"); // Given the choice between white and red, white will generally work better
    targetUrl.searchParams.set('rel', '0'); // Related videos will be shown, but only from the same channel
    return targetUrl.href;
};
const processVimeoUrl = (urlString)=>{
    const originalUrl = new URL(urlString);
    const id = originalUrl.searchParams.get('id') || originalUrl.pathname.split('/').pop();
    const target = new URL(id ? `https://player.vimeo.com/video/${id}` : urlString);
    target.searchParams.set("keyboard", "false"); // Keyboard controls can interfere with screen readers
    target.searchParams.set("dnt", "true"); // Setting this parameter to "true" blocks the player from collecting session data and analytics, similar to activating a Do Not Track feature in your browser.
    return target.href;
};
